export const NEWBORN_POSTPARTUM_SECTION_INITIAL_VALUES = {
  normal: false,
  notNormal: false,
  declined: false,
  normalDetails: [],
  notNormalDetails: [],
  notes: "",
};

export const NOSE_AND_MOUTH_FORM_INITIAL_VALUES = {
  sections: {
    naresNoseAndMouth: NEWBORN_POSTPARTUM_SECTION_INITIAL_VALUES,
    lipsNoseAndMouth: NEWBORN_POSTPARTUM_SECTION_INITIAL_VALUES,
    palateNoseAndMouth: NEWBORN_POSTPARTUM_SECTION_INITIAL_VALUES,
    frenulumNoseAndMouth: NEWBORN_POSTPARTUM_SECTION_INITIAL_VALUES,
  },
  notes: "",
};

export type NewbornPostpartumPhysicalExamsNoseAndMouthSections =
  keyof typeof NOSE_AND_MOUTH_FORM_INITIAL_VALUES.sections;
